module.exports = __webpack_public_path__ + "img/pop.9977d296.png";